import request from '@/utils/microSeviceFormatRequest'
import onlyNasFileUploadUseRequest from '@/utils/onlyNasFileUploadUseRequest'

export function getAllowedScheduleEvent (start, end) {
  return request({
    url: '/api/classtable/GetAllowedScheduleEvent',
    data: {
      startDate: start.toDateString(),
      endDate: end.toDateString()
    },
    method: 'post'
  })
}
export function insertSchedule (param) {
  return request({
    url: '/api/ClassTable/InsertSchedule',
    method: 'post',
    data: param,
    timeout: 3 * 60 * 1000
  })
}
export function getSelfScheduleLimitCheck (param) { //老师是否开启自主放课及限制放课天数
  return request({
    url: '/api/ClassTable/GetSelfScheduleLimitCheck',
    method: 'post',
    data: param
  })
}

export function getRestCourseCountOfNextWeek () { //下周可放课时数
  return request({
    url: '/api/ClassTable/GetRestCourseCountOfNextWeek',
    method: 'post'
  })
}